var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 303.48,
    height: 147.52,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 303.48 147.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#fff;}.cls-4{fill:url(#Degradado_sin_nombre_21);}.cls-2{opacity:.25;}.cls-2,.cls-3{mix-blend-mode:overlay;}.cls-5{fill:url(#Degradado_sin_nombre_39);}.cls-6{fill:#f44b3c;opacity:.3;}.cls-6,.cls-7,.cls-8{mix-blend-mode:multiply;}.cls-7{fill:#993eff;opacity:.5;}.cls-9{isolation:isolate;}.cls-8{fill:#022c90;opacity:.2;}.cls-10{fill:url(#Degradado_sin_nombre_25);}.cls-11{fill:url(#Degradado_sin_nombre_2);}.cls-3{opacity:.35;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: 186.34,
    y1: 146.77,
    x2: 116.85,
    y2: 1.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b31bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3c35bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3f44c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#445cc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4b7dcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#55a7da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#60dbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64ebec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_39",
    x1: 326.8,
    y1: 34.41,
    x2: -139.27,
    y2: 143.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35029c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#38039a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#420795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#530d8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6b1680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8a2271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#af305e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#dc4148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f44b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f6772b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fced00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25",
    x1: 32.64,
    y1: 58.98,
    x2: 57.92,
    y2: 90.99,
    gradientTransform: "translate(66.02 -9.98) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ba55ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8836da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5b19b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#3f08a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35029c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_21",
    x1: 282.86,
    y1: 82.22,
    x2: 253.77,
    y2: 42.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fced00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f6772b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f44b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#eb4c57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#de4e84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#d350a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ca52c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#c253e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#bd54f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ba54fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba55ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.3,25.6c-10.29,.59-10.4,.94-10.99,14.75-.59-13.81-.7-14.16-10.99-14.75,10.29-.59,10.4-.94,10.99-14.75,.59,13.81,.7,14.16,10.99,14.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.85,40.34c-6.08,.35-6.15,.51-6.5,7.95-.35-7.45-.41-7.61-6.5-7.95,6.08-.35,6.15-.51,6.5-7.95,.35,7.45,.41,7.61,6.5,7.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.2,111.77c-12.4,.71-12.54,1.13-13.24,17.77-.71-16.64-.85-17.07-13.24-17.77,12.4-.71,12.54-1.13,13.24-17.78,.71,16.64,.85,17.07,13.24,17.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.16,125.25c-8.64,.49-8.73,.72-9.23,11.29-.49-10.57-.59-10.8-9.23-11.29,8.64-.49,8.73-.72,9.23-11.29,.49,10.57,.59,10.8,9.23,11.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.13,107.42c-6.25,.36-6.32,.52-6.68,8.18-.36-7.65-.43-7.82-6.68-8.18,6.25-.36,6.32-.52,6.68-8.18,.36,7.65,.43,7.82,6.68,8.18Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 151.5,
    cy: 73.76,
    r: 73.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.74,73.76c0,2.07,.11,4.12,.27,6.15,11.51,13.26,28.48,21.66,47.42,21.66,34.68,0,62.79-28.11,62.79-62.79,0-12.4-3.61-23.95-9.81-33.69-8.34-3.27-17.41-5.09-26.91-5.09-40.74,0-73.76,33.02-73.76,73.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.36,7.22c11.17,12.93,17.94,29.76,17.94,48.18,0,40.74-33.02,73.76-73.76,73.76-11.41,0-22.22-2.59-31.86-7.22,13.53,15.66,33.51,25.58,55.83,25.58,40.74,0,73.76-33.02,73.76-73.76,0-29.33-17.12-54.65-41.9-66.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.93,23.81c-2.4,5.16-11.41,6.05-20.14,2-8.73-4.05-13.86-11.52-11.47-16.68,2.4-5.16,11.41-6.05,20.14-2,8.73,4.05,13.86,11.52,11.47,16.68Zm-.67,11.03c-4.13-1.92-8.39-1.49-9.52,.94-1.13,2.44,1.29,5.97,5.42,7.88,4.13,1.92,8.39,1.49,9.52-.94s-1.29-5.97-5.42-7.88Zm8.65-6.69c-2.82-1.31-5.74-1.02-6.52,.65-.77,1.67,.89,4.08,3.71,5.4,2.82,1.31,5.74,1.02,6.52-.65s-.89-4.08-3.71-5.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M303.12,33.2c-4.22-15.38-44.23-18.65-98.21-10.28,1.17,1.23,2.29,2.49,3.38,3.79,42.55-6.4,72.94-4.71,75.88,5.98,4.33,15.78-52.81,45.2-127.62,65.71C81.73,118.92,17.57,122.75,13.25,106.96c-3.01-10.98,23.73-28.56,65.47-45.15,.25-1.54,.55-3.05,.9-4.55C28.91,77.6-3.85,100.82,.36,116.2c5.75,20.99,78.19,19.43,161.79-3.49,83.6-22.92,146.71-58.51,140.96-79.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.86,25.05s.96,1.1,1.43,1.66c42.55-6.4,72.94-4.71,75.88,5.98,4.33,15.78-52.81,45.2-127.62,65.71C81.73,118.92,17.57,122.75,13.25,106.96c-3.01-10.98,23.73-28.56,65.47-45.15,.16-.98,.15-.99,.35-1.95C37.5,77.33,5.15,95.73,8.71,108.73c5.17,18.86,73.57,13.44,148.71-7.16,75.14-20.6,136.63-48.93,130.76-67.59-7.16-22.75-80.84-8.37-81.32-8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.16,109.35C78.56,132.27,6.12,133.83,.36,112.84c-.1-.38-.17-.77-.23-1.16-.24,1.57-.17,3.07,.23,4.51,5.75,20.99,78.19,19.43,161.79-3.49,82.19-22.53,144.56-57.31,141.19-78.42-3.08,21.3-63.22,53.69-141.19,75.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 45.06,
    cy: 74.7,
    r: 18.68,
    transform: "translate(-39.62 53.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.38,74.7c0,.64,.03,1.26,.09,1.88,2.82,3.76,7.31,6.21,12.37,6.21,8.55,0,15.48-6.93,15.48-15.48,0-4.1-1.6-7.81-4.2-10.58-1.61-.45-3.31-.71-5.07-.71-10.31,0-18.68,8.36-18.68,18.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.9,57.33c3.53,3.4,5.73,8.16,5.73,13.44,0,10.31-8.36,18.68-18.68,18.68-2.42,0-4.72-.47-6.84-1.31,3.36,3.24,7.92,5.24,12.95,5.24,10.31,0,18.68-8.36,18.68-18.68,0-7.9-4.91-14.64-11.84-17.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 267.9,
    cy: 61.75,
    r: 21.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M245.96,61.75c0,1.55,.16,3.07,.47,4.53,3.19,3.09,7.54,4.99,12.33,4.99,9.81,0,17.76-7.95,17.76-17.76,0-5.46-2.47-10.34-6.34-13.59-.75-.08-1.5-.12-2.27-.12-12.12,0-21.94,9.82-21.94,21.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.26,41.46c4.28,4,6.96,9.7,6.96,16.03,0,12.12-9.82,21.94-21.94,21.94-2.96,0-5.78-.59-8.36-1.65,3.92,3.67,9.19,5.92,14.98,5.92,12.12,0,21.94-9.82,21.94-21.94,0-9.16-5.61-17-13.58-20.29Z"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.81118a3d650a231fcc0daf1b215c885f.svg";
export { ForwardRef as ReactComponent };